import React from "react";
import { HeadphonesIcon } from "lucide-react";
import SolutionCard from "./cards/SolutionCard";

const CustomerSupportAgents = () => {
  return (
    <SolutionCard
      icon={HeadphonesIcon}
      title="Customer Support Agents"
      subtitle="Reliable 24/7 Customer Support"
      description="Provide exceptional customer service with AI-powered support agents"
    >
      <p className="text-muted-foreground">
        We help you build customer support agents that handle inquiries around
        the clock with SOTA performance on your business goals and evals. They
        learn from interactions to continuously improve service quality.
      </p>
    </SolutionCard>
  );
};

export default CustomerSupportAgents;
